import avatar_1 from 'assets/images/avatars/avatar_1.png';
import avatar_2 from 'assets/images/avatars/avatar_2.png';
import avatar_3 from 'assets/images/avatars/avatar_3.png';

const avatarsData = {
    avatar_1,
    avatar_2,
    avatar_3,
}

export default avatarsData;